import Spinner from '@xo-union/tk-component-spinner';
import React from 'react';

import { usePagesQuery } from '../../generated/graphql';
import { FullBleedContainer, TopLevelContainer, Row, Column } from '@xo-union/tk-component-grid';
import LeftContainer from '../LeftContainer';
import RightContainer from '../RightContainer';
import styles from './dashboard.scss';
import DashboardSnackbar from '../DashboardSnackbar';

const DashboardContent = () => {
  const { loading: pagesLoading } = usePagesQuery();

  const loading = pagesLoading;

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <FullBleedContainer>
      <TopLevelContainer>
        <Row>
          <Column xs="12">
            <div className={styles.dashboardWrapper}>
              <LeftContainer />
              <RightContainer />
            </div>
            <DashboardSnackbar />
          </Column>
        </Row>
      </TopLevelContainer>
    </FullBleedContainer>
  );
};

export default DashboardContent;
